import React from 'react'
import { Box } from 'components/Layout'
import { Button } from 'components/Button'
import history from '../../history'

const AppIsPendingReviewBanner = ({ inReview, appId }) => {
	const appSubPath = path => '/apps/' + appId + '/' + path
	return inReview
		? <Box
				header={'App is pending review'}
				body={
					"You cannot modify the app when it's pending review. If you need to change something, please cancel the submission, introduce the changes and submit the app again."
				}
				bodyPadding
				footer={
					<Button
						type={'ghost'}
						onClick={e => {
							history.push(appSubPath('distribution'))
						}}
					>
						Go to distribution
					</Button>
				}
			/>
		: null
}

export default AppIsPendingReviewBanner



// WEBPACK FOOTER //
// ./src/views/Banners/AppIsPendingReviewBanner.js